import { Box, Typography, Skeleton, useTheme } from "@mui/material";
import { StarRating } from "./StarRating";

interface ProductTitleProps {
  title?: string;
  stars?: number;
  reviewCount?: number;
  isLoading: boolean;
  variant: "mobile" | "desktop";
}

export const ProductTitle = ({
  title,
  stars,
  reviewCount = 0,
  isLoading,
  variant,
}: ProductTitleProps) => {
  const isMobile = variant === "mobile";
  const theme = useTheme();

  if (isLoading) {
    return (
      <Box
        sx={{
          padding: isMobile ? 0 : { xs: 2, sm: 2.5, md: 3 },
          background: isMobile
            ? "none"
            : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          borderRadius: isMobile ? 0 : 3,
          border: isMobile ? "none" : "1px solid #e8e8e8",
          boxShadow: isMobile ? "none" : "0 4px 16px rgba(0,0,0,0.06)",
          marginBottom: isMobile ? 0 : 3,
        }}
      >
        <Skeleton
          variant="text"
          sx={{
            fontSize: isMobile
              ? { xs: 20, sm: 24 }
              : { xs: 24, sm: 28, md: 32 },
            fontWeight: isMobile ? 700 : 800,
            mb: isMobile ? 1 : 2,
            lineHeight: 1.3,
            width: "100%",
          }}
        />
        <Skeleton
          variant="text"
          sx={{
            fontSize: 14,
            width: isMobile ? "60%" : "40%",
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: isMobile ? 0 : { xs: 2, sm: 2.5, md: 3 },
        background: isMobile
          ? "none"
          : "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
        borderRadius: isMobile ? 0 : 3,
        border: isMobile ? "none" : "1px solid #e8e8e8",
        boxShadow: isMobile ? "none" : "0 4px 16px rgba(0,0,0,0.06)",
        marginBottom: isMobile ? 0 : 3,
      }}
    >
      <Typography
        sx={{
          fontSize: isMobile ? { xs: 20, sm: 24 } : { xs: 24, sm: 28, md: 32 },
          fontWeight: isMobile ? 700 : 800,
          mb: isMobile ? 1 : 2,
          lineHeight: isMobile ? 1.3 : 1.2,
          color: "text.primary",
          ...(isMobile
            ? {}
            : {
                background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark || theme.palette.secondary.main} 100%)`,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }),
        }}
      >
        {title}
      </Typography>
      {stars && <StarRating stars={stars} reviewCount={reviewCount} />}
    </Box>
  );
};
